import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class AccHistoryResultDto {
    beginStep: string;
    endStep: string;
    action: string;
    data: string;

    @Type(() => Date)
    actionOn: Date;
    additionalInfo: string;

    @Type(() => UserNameDisplayResultDto)
    userInfo: UserNameDisplayResultDto;
}
